/* Send Post message to parent window if it exists (when site is integrated by some provider) */
export const sendPostMessageToParent = (message, targetOrigin = "*") => {
	if (!message || window.parent === window) {
		return;
	}
	window.parent.postMessage(message, targetOrigin);
};
